export default __webpack_public_path__ + "static/media/white.3fed956f.png";